<template>
<div class="container h-100">

    <!-- Outer Row -->
    <div class="row align-items-center h-100">

      <div class="col-4 mx-auto login-panel">

        <div class="text-center">
          <h1 class="h4 text-gray-900 mb-4">Welcome Back!</h1>
        </div>
        <div class="form-group">
          <input v-model="email" type="email" class="form-control form-control-user" id="inputEmail" placeholder="Email">
        </div>
        <div class="form-group">
          <input v-model="password" type="password" class="form-control form-control-user" id="inputPassword" placeholder="Password">
        </div>
        <div class="form-group">
          <button @click="login()" class="btn btn-primary btn-user btn-block col-4 ml-auto">
            Login
          </button>
        </div>

        <div class="error-div" v-if="loginError">
          <span>
            Credentials are invalid, please contact the administrator
            for more information
          </span>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
// @ is an alias to /src
import router from '@/router';
import UsersApiRequest from '@/components/ApiRequester/User.js';
import store from '@/store/index';
//import {GridTable} from '@dmunoz/gridtable';
export default {

  name: 'login',
  data() {
    return {
      email: '',
      password: '',
      sendingRequest: false,
      requestSent: false,
      requestFail: false,
      loginError: false,
      formErrors: {},
      gridColumns: [
        {
          column: 'test 1', index: 'test_1', type:'raw',
        },
        {
          column: 'test 2', index: 'test_2', type:'raw',
        },
      ],
    };
  },
  mounted() {
    document.getElementById('app').classList.add('login');
  },
  components: {
    //'grid-table': GridTable
  },
  methods: {
    login() {
      document.getElementById('loader').classList.add('active');
      const usersApiRequest = new UsersApiRequest();
      const payload = {
        email: this.email,
        password: this.password,
      };
      this.formErrors = {};
      this.sendingRequest = true;
      const self = this;
      const selfRouter = router;
      const inputEmail = document.getElementById('inputEmail');
      const inputPassword = document.getElementById('inputPassword');
      inputEmail.classList.remove('input-error');
      inputPassword.classList.remove('input-error');
      usersApiRequest.postLogin(payload)
        .then((response) => {
          localStorage.setItem('accessToken', response.data.token);
          //localStorage.setItem('refreshToken', response.data.token.refresh_token);
          //localStorage.setItem('verified', response.data.verified ? true : '');

          localStorage.setItem('userName', response.data.user.name);
          localStorage.setItem('userRole', response.data.user.role);
          localStorage.setItem('userId', response.data.user.id);

          store.dispatch({
            type: 'user/updateAccessToken',
            accessToken: response.data.token,
            userRole: response.data.user.role,
            userName: response.data.user.name,
            userId: response.data.user.id,                                    
          });
          // store.dispatch({
          //   type: 'user/updateRefreshToken',
          //   refreshToken: response.data.token.refresh_token,
          // });

        store.dispatch({ type: 'user/updateIsLoggedIn', isLoggedIn: true });
          document.getElementsByTagName('BODY')[0].classList.remove('bg-dark');
          document.getElementById('loader').classList.remove('active');
          selfRouter.push('/dashboard');
        })
        .catch((error) => {
          this.loginError = true;
          inputEmail.classList.add('input-error');
          inputPassword.classList.add('input-error');
          window.console.log('Bad: ', error.response);
          self.sendingRequest = false;
          document.getElementById('loader').classList.remove('active');
        });
      }
    }
}
</script>
